// extracted by mini-css-extract-plugin
export default {"input":"Una-z","button":"Vna-z","selected":"Wna-z","sephoraImage":"Xna-z","unavailable":"Yna-z","image":"Zna-z"};